export default __webpack_public_path__ + "static/media/locator.4e44f078.svg";